import type { LoyaltyLedger } from '@doneverse/shared'
import { api } from '../api/index.js'

/**
 * The signed-in doer's loyalty standing (Chunk 1 ledger, ClickUp 86d36nqnv).
 * `balance` is the sum of every ledger delta for the doer; `entries` is their
 * transaction history newest-first. Mirrors the API's `GET /v1/me/loyalty`.
 */
export interface LoyaltySummary {
  balance: number
  entries: LoyaltyLedger[]
}

export const loyaltyService = {
  /**
   * The acting doer's own loyalty balance + ledger history. User-scoped (the
   * balance sums across every workspace the doer earns in), not workspace-scoped.
   */
  fetchSummary: async (): Promise<LoyaltySummary> => {
    return api.get('/v1/me/loyalty').json<LoyaltySummary>()
  },
}
